import React, { forwardRef } from 'react';
import { BeautifulMentionNode } from 'lexical-beautiful-mentions';

import { ColumnMentionComponent } from './ColumnMentionComponent';

class ColumnMentionNode extends BeautifulMentionNode {
  constructor(trigger, value, data, key, selectedEnumValue = null) {
    if (!value || !data.column) {
      throw new Error('Cannot create ColumnMentionNode without required data');
    }
    super(trigger, value, data, key);

    this.selectedEnumValue = selectedEnumValue;
  }

  static getType() {
    return 'columnMention';
  }

  static clone(node) {
    return new ColumnMentionNode(
      node.__trigger,
      node.__value,
      node.__data,
      node.__key,
      node.selectedEnumValue
    );
  }

  static importJSON(serializedNode) {
    return new ColumnMentionNode(
      serializedNode.trigger,
      serializedNode.value,
      serializedNode.data,
      serializedNode.key,
      serializedNode.selectedEnumValue
    );
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: 'columnMention',
      trigger: this.__trigger,
      value: this.__value,
      data: this.__data,
      selectedEnumValue: this.selectedEnumValue
    };
  }

  createDOM() {
    const node = document.createElement('span');
    node.style.display = 'inline-flex';
    node.style.verticalAlign = 'middle';
    node.style.wordBreak = 'break-word';
    node.style.overflowWrap = 'break-word';
    node.style.maxWidth = '100%';
    node.setAttribute('data-tooltip', this.getData().columnDescription);

    return node;
  }

  // eslint-disable-next-line class-methods-use-this
  updateDOM() {
    return false;
  }

  component() {
    const nodeKey = this.getKey();
    const { selectedEnumValue } = this;

    const Component = forwardRef((props, ref) => (
      <ColumnMentionComponent
        nodeKey={nodeKey}
        selectedEnumValue={selectedEnumValue}
        {...props}
        ref={ref}
      />
    ));

    return Component;
  }

  getTextContent() {
    return this.selectedEnumValue
      ? `${this.getTrigger()}${this.getValue()} = ${this.selectedEnumValue}`
      : `${this.getTrigger()}${this.getValue()}`;
  }
}

export { ColumnMentionNode };
